define('xml-to-json/xml-to-json',['require','exports','module','xml-doc/xml-doc'],function(require,exports,module){
	var parseXML = require('xml-doc/xml-doc');

    var EMPTY="",
        OBJECT='object',
        keepns=false,
        nows=/\s*/g,
        nons=/^.*:/,
        config = {ns : keepns},
        concat=[].concat,
        
        isArray=Array.isArray || (function(){

        	var toString=Object.prototype.toString,
        		arrType="[object Array]";	

        	return function(obj){
        		return toString.call(obj)===arrType;
        	};
        }),
        ensureArray=function(obj){
            return obj && (isArray(obj) ? obj : [obj]) || [];
        },

        parse   =  function(doc,_jsroot){
            return doc && doc.documentElement ? node(doc.documentElement,_jsroot) : false;
        },
        
        node = function(_node,_jsnode){
            if(!_node){
                return "";
            }
            //_node.normalize();
            var jsroot=_jsnode||{},
                jsnode={},
                textbuff='',
                childMap={},
                childList=[],
                childLen=0,
                hasAttr=!!(_node.attributes && _node.attributes.length),

                _name=simplename(_node);         

            each.call(_node.attributes,function(v,i,a){
                store(jsnode,a.item(i));
            });

            each.call(_node.childNodes,function(v,i,a){
                var subnode=a.item(i),
                    subnodename,
                    type=subnode.nodeType;

                if(type===4 || type===3){
                        textbuff+=ensureText(subnode.nodeValue || subnode.text || EMPTY);
                } else if (type===8){
                } else {
                    subnodename=simplename(subnode);
                    childMap[subnodename]=(childMap[subnodename]!==undefined ? childMap[subnodename]+1 : 0);
                    childList[childLen++]={
                        name : subnodename,
                        index: childMap[subnodename]
                    };
                    jsnode=(type===9 ? parse : node)(subnode,jsnode);
                }
            });
                
            if(!hasAttr && childLen<1){
                jsnode=textbuff;
            }else {
                if(childLen){
                    childList.get=function(index){
                        var child=childList[index||0];
                        return ensureArray(jsnode[child.name])[child.index];
                    };
                    jsnode._childList=childList;
                }
                if(textbuff){
                    jsnode._text=textbuff;
                }
            }
            jsnode._nodeName=_name;
            jsroot[_name]=cancat(jsroot[_name],jsnode);
            return jsroot;
        },
        
        simplename=function(_node){
            return keepns ? _node.nodeName : (_node.localName || _node.nodeName.replace(nons,EMPTY));
        },
        
        each = function(cb){
            var i=0,
                len=this.length || 0;

            for(; i< len; i++){
                cb(this[i],i,this);
            }
        },
        
        serial_merge = function(o1,o2){
            var key;
            for(key in o2){
                o1[key] = cancat(o1[key],o2[key]);
            }
            return o1;
        },

        cancat = function(left,right){
            return typeof right===OBJECT && left ? concat.call(left,right) : right;
        },

        store = function(jsnode,node){
            jsnode[simplename(node)]=node.nodeValue;
        },

        ensureText = function(txt){
            return txt.replace(nows,EMPTY) ? txt : EMPTY;
        };

        /**
         * XML to JSON parser
         * @param  {mixed} doc xml document or document text to be parsed
         * @param  {Object} opts configure parsing options.  Currently supports property
         * 					ns : true|false.  ns== true will preserve xml namespaces. Defaults to false.
         * @return {Object}
         */
        return function(doc,opts){
        	var xml=parseXML.parse(doc);
            if(opts){
                serial_merge(config,opts);
                keepns=config.ns;
            }
            return parse(xml);
        }
});
